import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/Terms&PrivacySocialApi/ServiceLinks";
import { validateForm } from "utils/validation";
import { ServiceLinksRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddServiceLinksForm from "./Componates/AddServiceLinksForm";
import fields from "../json/TermsAndPrivacyFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddServiceLinks = () => {
  const navigate = useNavigate();
  const { formdataservice } = fields;

  // Initialize form values from JSON
  const initialValues = formdataservice.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const { values, errors, handleChange, handleFileChange, setErrors } =
    useFormChange(initialValues, ServiceLinksRules);

  // Submit Handler using custom hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) =>
        formData.append(key, val ?? "")
      );
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, ServiceLinksRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Service links added successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddServiceLinksForm
        fields={formdataservice}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Add Service Links"
      />
    </>
  );
};

export default AddServiceLinks;
